// extracted by mini-css-extract-plugin
module.exports = {"anchorButton":"TextButton-module__anchorButton___kjlkX","standard":"TextButton-module__standard___NggOA","inline":"TextButton-module__inline___3lnGj"};